
WW.toggleSiteSearch = function($){
    'use strict';
    let openState = false;
    const toggle = (bodyClick) => {
        openState = !openState;

        if (openState) {
            $('body')
                .addClass('is-open--site-search')
                .css({
                    'padding-right' : WW.scrollbarWidth,
                    'overflow' : 'hidden'
                });
        } else {
            $('body')
                .removeClass('is-open--site-search')
                .css({
                    'padding-right' : 0,
                    'overflow' : 'auto'
                });
        }
    };

    $('.js-search-toggle').on('click', function(e) {
        e.stopPropagation();
        toggle();
    });
    $('body').on('click', function() {
        if (openState) {
            toggle();
        }
    });
    $('.js-site-search').on('click', function(e) {
        e.stopPropagation();
    });
    return this;
};
